import React from "react";
import { useSceneStore } from "../../store/sceneStore";

export function OrbitVisibilityControl() {
  const showOrbits = useSceneStore((s) => s.showOrbits);
  const showPlanets = useSceneStore((s) => s.showPlanets);
  const showMoons = useSceneStore((s) => s.showMoons);
  const showLabels = useSceneStore((s) => s.showLabels);
  const showAxes = useSceneStore((s) => s.showAxes);
  const showVelocityVectors = useSceneStore((s) => s.showVelocityVectors);
  const showReferencePlane = useSceneStore((s) => s.showReferencePlane);

  return (
    <div className="tls-astro-control-block">
      <label>Visibilidade</label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showPlanets}
          onChange={(e) =>
            useSceneStore.getState().setShowPlanets(e.target.checked)
          }
        />
        Planetas
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showMoons}
          onChange={(e) =>
            useSceneStore.getState().setShowMoons(e.target.checked)
          }
        />
        Luas
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showOrbits}
          onChange={(e) => useSceneStore.getState().setShowOrbits(e.target.checked)}
        />
        Órbitas
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showLabels}
          onChange={(e) => useSceneStore.getState().setShowLabels(e.target.checked)}
        />
        Nomes
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showAxes}
          onChange={(e) => useSceneStore.getState().setShowAxes(e.target.checked)}
        />
        Eixos (corpo selecionado)
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showVelocityVectors}
          onChange={(e) =>
            useSceneStore.getState().setShowVelocityVectors(e.target.checked)
          }
        />
        Vetores de velocidade
      </label>
      <label className="tls-astro-check">
        <input
          type="checkbox"
          checked={showReferencePlane}
          onChange={(e) =>
            useSceneStore.getState().setShowReferencePlane(e.target.checked)
          }
        />
        Plano de referência
      </label>
    </div>
  );
}
